<script>
  import { helpers, maxLength, numeric } from '@vuelidate/validators'

  import { use_submittable_field_input_autofocus_and_press_enter_mixin } from '@/components/Fields/SubmittableField/SubmittableFieldViewUtils/submittable_field_input_autofocus_and_press_enter_mixin'
  import submittable_field_view_mixin from '@/components/Fields/SubmittableField/SubmittableFieldViewUtils/submittable_field_view_mixin'

  export default {
    name: 'Submittable__Number',
    mixins: [
      submittable_field_view_mixin,
      use_submittable_field_input_autofocus_and_press_enter_mixin('input'),
    ],
    components: {
      GenericStringSingleLineFieldViewInput: () =>
        import(
          '@/components/Fields/GenericFieldViews/GenericTextField/GenericStringSingleLineFieldViewInput'
        ),
    },
    computed: {
      validationRules() {
        const rules = []

        // Add required validation if field is required
        if (this.sourceObj.properties.required) {
          rules.push(value => !!value || 'This field is required')
        }

        // Add max length validation if specified
        if (this.sourceObj.properties.max_characters) {
          rules.push(maxLength(this.sourceObj.properties.max_characters))
        }

        // Add numeric validation
        rules.push(
          helpers.withMessage('This entry can only contain numbers', numeric)
        )

        return rules
      },
    },
    methods: {
      handleValidation(isValid) {
        // Emit validation event to parent
        this.$emit('validation', isValid)
      },
    },
  }
</script>

<template>
  <GenericStringSingleLineFieldViewInput
    ref="input"
    v-model.number="submissionObj.value"
    v-input-mask="/^\d*$/"
    :placeholder="sourceObj.content.placeholder"
    field-type="number"
    :rules="validationRules"
    :validate-on-input="true"
    assign-generic-view-class
    @validation="handleValidation"
    v-on="inputAutofocusOn"
  />
</template>
